import React from 'react';
import { OrderProps } from '../order_form/OrderForm';


export interface ModalProps {
  active: boolean
  title?: string
  onClose?: Function
}


class Modal extends React.Component<ModalProps> {

  private el: React.RefObject<HTMLDivElement>;
  private $modal: JQuery<HTMLDivElement> | undefined;


  constructor(props: ModalProps) {
    super(props);
    this.el = React.createRef<HTMLDivElement>();
  }


  componentDidMount() {
    if (!(window as any).jQuery) {
      window.addEventListener('DOMContentLoaded', this.initmodal);
    } else {
      this.initmodal();
    }    
  }

  initmodal = () => {
    const $ = (window as any).jQuery;
    const el = this.el!.current!
    this.$modal = $(el);

    // move my dom to the body
    window.document.body.appendChild(el);

    if (this.props.active) {
      (this.$modal as any).modal('show');
    }
  }


  componentWillUnmount() {
    // stop listening
    if (this.$modal) {
      this.$modal.off('hidden.bs.modal');
    }

    // destroy dom
    window.document.body.removeChild(this.el.current!);
  }


  componentDidUpdate(prevProps: OrderProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        (this.$modal as any).modal('show');
      } else {
        (this.$modal as any).modal('hide');
      }
    }
  }


  render() {
    return (
    <div className="modal fade" tabIndex={-1} ref={this.el}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{this.props.title}</h5>
            <button type="button" className="close" aria-label="Close" onClick={this.close}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            
            {this.props.children}

          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    );
  }


  close = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  }

}


export default Modal;
